import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Switch } from 'antd';
import { editSpecialtyAction } from 'src/modules/SuperAdmin/store/actions/specialty.action';
import { useSelector } from 'react-redux';
import { SuperAdminModal } from '../../../baseComponents';
import * as Yup from 'yup';
import { getFromStorage } from 'src/lib/storage';

const EditSpecialty = ({
  isOpen,
  setIsOpen,
  isfilterOn,
  selectedSpecialty,
}) => {
  const dispatch = useDispatch();

  const cachedUserEmail = getFromStorage(`user_email`);
  const { getSpecialtyById } = useSelector((state) => state?.specialtyState);
  const [isPublic, setIsPublic] = useState(true);

  useEffect(() => {
    setIsPublic(getSpecialtyById?.is_public);
  }, [getSpecialtyById]);

  const initialValues = {
    specialty_name: getSpecialtyById?.specialty_name,
  };

  const validationSchemaField = Yup.object().shape({
    specialty_name: Yup.string().required('Specialty name is required'),
  });

  const sections = [
    {
      heading: (
        <>
          <div className="flex">
            <div>Edit specialty</div>
          </div>
          <div className="mb-4 mt-4">
            <span className="text-sm" style={{ fontWeight: 'normal' }}>
              Public
            </span>
            <Switch
              className="mx-1"
              style={{ backgroundColor: '#00000040' }}
              value={isPublic}
              onChange={(e) => setIsPublic(e)}
            />
          </div>
        </>
      ),

      fields: [
        {
          name: 'specialty_name',
          type: 'text',
          title: 'Specialty name',
          placeholder: 'Specialty name',
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      initialValues={initialValues}
      validationSchema={validationSchemaField}
      className={'specialty-modal'}
      closable={false}
      submitButtonText="Submit"
      cancelButtonText="Cancel"
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={(values) => {
        const payload = {
          specialty_name: values?.specialty_name,
          is_public: isPublic,
          last_modified_by: cachedUserEmail,
        };
        dispatch(
          editSpecialtyAction(
            getSpecialtyById?.specialty_id,
            payload,
            setIsOpen,
            isfilterOn,
            selectedSpecialty
          )
        );
      }}
    />
  );
};

export default EditSpecialty;
